<template>
  <div class="basket__row basket__product">
    <div class="basket__product-title">
      <h3>{{ product.product_name }} ({{ product.product_code }})</h3>
    </div>
    <div class="basket__product-price">
      <span v-html="price"></span>
    </div>
    <div class="basket__product-quantity">
      <input
        type="number"
        min="0"
        max="999"
        step="1"
        v-model="product.quantity">

      <button class="btn--text" @click.prevent="updateQuantity">
        <svg role="presentation">
          <use xmlns:xlink="http://www.w3.org/1999/xlink"
               xlink:href="#svg--refresh">
          </use>
        </svg>
        <span>{{locale.update}}</span>
      </button>
    </div>
    <div class="basket__product-total">
      <div>{{locale.line_total}} ({{locale.ex_vat}})</div>
      <span v-html="totalPrice"></span>
    </div>
    <div class="basket__product-remove">
      <button class="btn--remove" @click.prevent="removeItem">
        <span class="visually-hidden">{{locale.remove_item}}</span>
        <svg role="presentation">
          <use xmlns:xlink="http://www.w3.org/1999/xlink"
               xlink:href="#svg--close">
          </use>
        </svg>
      </button>
    </div>
    <div class="basket__product-delegate" v-if="allowDelegates">
      <div class="delegate__action">
        <button class="btn--text"
                @click.prevent="addDelegates"
                v-if="!showDelegates">+ {{locale.add_delegate_names}}</button>
      </div>
      <ul class="delegate__list" v-if="showDelegates">
        <li v-for="delegate in basket_product.delegates" :key="delegate.id">
          <input type="text"
                 maxlength="50"
                 :placeholder="locale.enter_delegate_name"
                 v-model.trim="delegate.name">
        </li>
      </ul>
      <div class="delegate__action">
        <button class="btn--text"
                @click.prevent="saveDelegates"
                v-if="showDelegates">{{locale.save_delegate_names}}</button>
      </div>
      <div class="delegate__action">
        <button class="btn--text"
                @click.prevent="removeDelegates"
                v-if="showDelegates">{{locale.remove_delegate_names}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import numeral from 'numeral';
import { mapGetters } from 'vuex';

export default {
  props: ['basket_product'],
  data() {
    return { product: this.basket_product };
  },
  created() {
    if (this.basket_product.delegates.length <= 0) {
      return null;
    }

    const delegatesNeeded = this.basket_product.quantity
                          - this.basket_product.delegates.length;

    for (let x = 0; x < delegatesNeeded; x += 1) {
      this.basket_product.delegates.push({ id: null, name: null });
    }

    return null;
  },
  methods: {
    updateQuantity() {
      this.$store.dispatch('updateBasketProductQuantity', this.basket_product);
    },
    removeItem() {
      this.$store.dispatch('removeBasketProduct',
        { id: this.basket_product.id });
    },
    formatCurrency(price) {
      return `${this.locale.currency_symbol}${numeral(price).format(this.locale.currency_mask)}`;
    },
    addDelegates() {
      this.$store.dispatch('addBasketProductDelegates', this.basket_product);
    },
    removeDelegates() {
      this.$store.dispatch('removeBasketProductDelegates', this.basket_product);
    },
    saveDelegates() {
      this.$store.dispatch('updateBasketProductDelegates', this.basket_product);
    },
  },
  computed: {
    ...mapGetters([
      'locale',
    ]),
    showDelegates() {
      return this.basket_product.delegates.length > 0;
    },
    allowDelegates() {
      return this.basket_product.allow_delegates;
    },
    totalPrice() {
      return this.formatCurrency(this.product.total);
    },
    price() {
      return this.formatCurrency(this.product.price);
    },
    quantity() {
      return this.basket_product.quantity;
    },
  },
};
</script>
